import React from "react";
import { useMail } from "../../../contexts/mailContext/mailContext.js";
import { useLightBox } from "../../../contexts/lightBoxContext/lightBoxContext.js";
import { useSideBar } from "../../../contexts/sideBarContext/sideBarContext.js";

const LightBoxFooter = ({ children }) => {
  const { getSideBarViewLightBox } = useSideBar();
  const { getFileId } = useLightBox();
  const {
    getCurrentFolderData,
    getCurrentFolder,
    getMailMetaData,
    getFilesList,
  } = useMail();

  const filteredList = getFilesList().filter((itemId) => !itemId.folder);

  const currentIndex = filteredList.indexOf(getFileId());

  return (
    <div
      className={`lightBox-footer ${
        getSideBarViewLightBox() ? "lightbox-open" : ""
      }`}
    >
      {currentIndex > -1 ? (
        <div className="files-number">
          {/* <Icon name="arrow-left" white /> */}
          <span>
            {currentIndex + 1}/
            {getCurrentFolder()
              ? getCurrentFolderData().fileCount
              : getMailMetaData().filesCount}
          </span>
          {/* <Icon name="arrow-right" white /> */}
        </div>
      ) : null}
    </div>
  );
};

export default LightBoxFooter;
